//import Cookies from 'js-cookie'
import store from '@/store'

const setting = {
  state: {
    bible: {
      options: [
        { value: 'SI', text: '聖書協会共同訳', },
        { value: 'NI', text: '新共同訳', },
        { value: 'JC', text: '口語訳', },
        { value: 'ES', text: 'The English Standard Version', },
      ],
    },
    ruby: {
      value: !+(localStorage.getItem('setting.ruby') || 1) ? 0 : 1,
      options: [
        { value: 0, text: 'なし', },
        { value: 1, text: 'あり', },
      ],
    },
    reference: {
      value: !+(localStorage.getItem('setting.reference') || 1) ? 0 : 1,
      options: [
        { value: 0, text: 'なし', },
        { value: 1, text: 'あり', },
      ],
    },
    annotation: {
      value: !+(localStorage.getItem('setting.annotation') || 1) ? 0 : 1,
      options: [
        { value: 0, text: 'なし', },
        { value: 1, text: 'あり', },
      ],
    },
    subheading: {
      value: !+(localStorage.getItem('setting.subheading') || 1) ? 0 : 1,
      options: [
        { value: 0, text: 'なし', },
        { value: 1, text: 'あり', },
      ],
    },
    apocrypha: {
      value: !+(localStorage.getItem('setting.apocrypha') || 1) ? 0 : 1,
      options: [
        { value: 0, text: 'なし', },
        { value: 1, text: 'あり', },
      ],
    },
    study: {
      value: !+(localStorage.getItem('setting.study') || 1) ? 0 : 1,
      options: [
        { value: 0, text: 'なし', },
        { value: 1, text: 'あり', },
      ],
    },
    fontSize: {
      value: Number.isInteger(parseInt(localStorage.getItem('setting.fontSize'))) ? parseInt(localStorage.getItem('setting.fontSize')) : 1,
      min: 0,
      max: 10,
    },
    vspace: {
      value: Number.isInteger(parseInt(localStorage.getItem('setting.vspace'))) ? parseInt(localStorage.getItem('setting.vspace')) : 5,
      min: 0,
      max: 10,
    },
  },
  mutations: {
    SETTING_CHANGE_BIBLE: (state, value) => {
      if (typeof value === undefined) {
        state.bible.value = !state.bible.value
      } else {
        state.bible.value = value
      }
      localStorage.setItem('setting.bible', state.bible.value)
    },

    SETTING_TOGGLE_RUBY: (state, value) => {
      if (typeof value === undefined) {
        state.ruby.value = !state.ruby.value
      } else {
        state.ruby.value = value
      }
      localStorage.setItem('setting.ruby', state.ruby.value)
    },

    SETTING_TOGGLE_REFERENCE: (state, value) => {
      if (typeof value === undefined) {
        state.reference.value = !state.reference.value
      } else {
        state.reference.value = value
      }
      localStorage.setItem('setting.reference', state.reference.value)
    },
    
    SETTING_TOGGLE_ANNOTATION: (state, value) => {
      if (typeof value === undefined) {
        state.annotation.value = !state.annotation.value
      } else {
        state.annotation.value = value
      }
      localStorage.setItem('setting.annotation', state.annotation.value)
    },
   
    SETTING_TOGGLE_SUBHEADING: (state, value) => {
      if (typeof value === undefined) {
        state.subheading.value = !state.subheading.value
      } else {
        state.subheading.value = value
      }
      localStorage.setItem('setting.subheading', state.subheading.value)
    },

    SETTING_TOGGLE_APOCRYPAH: (state, value) => {
      if (typeof value === undefined) {
        state.apocrypha.value = !state.apocrypha.value
      } else {
        state.apocrypha.value = value
      }
      localStorage.setItem('setting.apocrypha', state.apocrypha.value)
    },

    SETTING_TOGGLE_STUDY: (state, value) => {
      if (typeof value === undefined) {
        state.study.value = !state.study.value
      } else {
        state.study.value = value
      }
      localStorage.setItem('setting.study', state.study.value)
    },

    SETTING_CHANGE_FONT_SIZE: (state, value) => {
      state.fontSize.value = value
      localStorage.setItem('setting.fontSize', state.fontSize.value)
    },

    SETTING_CHANGE_VSPACE: (state, value) => {
      state.vspace.value = value
      localStorage.setItem('setting.vspace', state.vspace.value)
    },
  },

  actions: {
    settingChangeBible: ({ commit }, value) => {
      commit('SETTING_CHANGE_BIBLE', value)
    },

    settingToggleRuby: ({ commit }, value) => {
      commit('SETTING_TOGGLE_RUBY', value)
    },

    settingToggleReference: ({ commit }, value) => {
      commit('SETTING_TOGGLE_REFERENCE', value)
    },

    settingToggleAnnotation: ({ commit }, value) => {
      commit('SETTING_TOGGLE_ANNOTATION', value)
    },

    settingToggleSubheading: ({ commit }, value) => {
      commit('SETTING_TOGGLE_SUBHEADING', value)
    },

    settingToggleApocrypha: ({ commit }, value) => {
      commit('SETTING_TOGGLE_APOCRYPAH', value)
      store.dispatch('dataSetBibleSearchBookCode', store.state.data.search.bookCode)
    },

    settingToggleStudy: ({ commit }, value) => {
      commit('SETTING_TOGGLE_STUDY', value)
    },

    settingChangeFontSize: ({ commit }, value) => {
      commit('SETTING_CHANGE_FONT_SIZE', value)
    },

    settingChangeVSpace: ({ commit }, value) => {
      commit('SETTING_CHANGE_VSPACE', value)
    },
  }
}

export default setting
